import { checkRU, BACKEND_URL } from '../../index';
import { Link } from "react-router-dom";
import RouteUrl from '../RouteEnum';
import "./LangButton.css";

const LangButton = () => {
    const { isRu, apiUrl } = checkRU();
    const buttonText = isRu ? "UA" : "RU";
    const linkUrl = isRu ? window.location.pathname.replace(/\/ru\/|\/ru$/, '/') : '/ru' + window.location.pathname;

    return (
        <div className="lang-button">
            <Link reloadDocument to={linkUrl} style={{ color: "inherit" }}>{buttonText}</Link>
        </div>
    );
}

export default LangButton;